import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element);
    this.showModal();
  }

  showModal() {
    this.modal.show();
  }

  checkDiscountLink() {
    const discountNoticeModal = document.getElementById("discountNoticeModal");
    if (discountNoticeModal) {
      const modal = bootstrap.Modal.getOrCreateInstance(discountNoticeModal);
      if (!discountNoticeModal.classList.contains("show")) {
        modal.show();
      }
    }
  }

  // This front end shows the discount notice first, then opens the delivery-type modal
  // when the notice is dismissed (reverse of checkDiscountLink). No-op when the
  // type modal isn't rendered (e.g. user already selected a delivery type).
  checkTypeModal() {
    const deliveryTypeModal = document.getElementById("deliveryTypeModal");
    if (deliveryTypeModal) {
      const modal = bootstrap.Modal.getOrCreateInstance(deliveryTypeModal);
      if (!deliveryTypeModal.classList.contains("show")) {
        modal.show();
      }
    }
  }
}
